import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NavigationState {
  isClosed: boolean;
}

const SIDE_MENU_CLOSED_STORAGE_KEY = "sideMenuClosed";

const getStoredSideMenuClosed = (): boolean => {
  try {
    return localStorage.getItem(SIDE_MENU_CLOSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

const saveSideMenuClosed = (isClosed: boolean) => {
  try {
    localStorage.setItem(SIDE_MENU_CLOSED_STORAGE_KEY, String(isClosed));
  } catch {
    // Ignore storage errors, navigation state should still work in memory.
  }
};

const initialState: NavigationState = {
  isClosed: getStoredSideMenuClosed(),
};

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setIsClosed: (state, action: PayloadAction<boolean>) => {
      state.isClosed = action.payload;
      saveSideMenuClosed(action.payload);
    },
    toggleIsClosed: (state) => {
      state.isClosed = !state.isClosed;
      saveSideMenuClosed(state.isClosed);
    },
  },
});

export const { setIsClosed, toggleIsClosed } = navigationSlice.actions;
export default navigationSlice.reducer;
